// @flow
/** @jsx jsx */

import { Colors, Forms } from '@zapier/theme';
import { css, jsx } from '@emotion/core';

import Dropdown from 'app/common/components/Dropdown';

type SuggestionItem = string;

type Props = {
  getItemProps: (props: { item: SuggestionItem, index: number }) => {},
  getMenuProps: (props: { 'aria-label': string }) => {},
  highlightedIndex: number,
  items: Array<SuggestionItem>,
};

const getSuggestionCss = ({ isHighlighted, showBorder }) =>
  css({
    ...(showBorder ? { borderBottom: Forms.field.border } : {}),
    ...(isHighlighted ? { backgroundColor: Colors.storm } : {}),
    padding: '5px 10px',
  });

const SuggestionsDropdown = ({
  getItemProps,
  getMenuProps,
  highlightedIndex,
  items,
}: Props) => {
  return (
    <aside {...getMenuProps({ 'aria-label': 'List of injected fields' })}>
      <Dropdown kind="below justify-right block" tag="ul">
        {items.map((item, index, all) => (
          <li
            {...getItemProps({ index, item })}
            aria-label="Auto-complete Suggestion"
            css={getSuggestionCss({
              isHighlighted: highlightedIndex === index,
              showBorder: index < all.length - 1,
            })}
            key={item}
          >
            {item}
          </li>
        ))}
      </Dropdown>
    </aside>
  );
};

SuggestionsDropdown.defaultProps = {
  items: [],
};

export default SuggestionsDropdown;
